import { DefaultIconProps } from './types';
import { CHEVRON_DOWN_ICON_URL } from './urls';

export const ChevronDownIcon = ({ className, ...props }: DefaultIconProps) => (
  <img
    className={className}
    src={CHEVRON_DOWN_ICON_URL}
    alt="chevron-down"
    {...props}
  />
);
